var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPossible4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 70,
    viewBox: "0 0 46 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164139"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 163287"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 83232",
    d: "M-11968.521-13281.727h40.924v-21.957l-15.408 15.406-10.038-10.039-15.478 14.246z",
    transform: "translate(11970.986 13336.469)",
    style: {
      fill: "#ffd133"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35 32.995V31.1l15.959-16.083L33.4 25.109 49.488 9.15v1.956L33.4 27.065 23.309 16.972zm40.75 15.9V26.119l1.388-1.388v24.16zm-30.531 0V36.212l1.388-1.388v14.067zm10.156 0V34.824l1.388 1.451v12.616zm10.219 0v-12.62l1.388-1.388v14zm-30.594 0V46.3l1.388-1.388v3.974z",
    transform: "translate(-5.35 5.85)",
    style: {
      fill: "#191919"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossible4);
export default __webpack_public_path__ + "static/media/possible-4.4db529fff5cf82ea2aa64cc664db8181.svg";
export { ForwardRef as ReactComponent };